// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3_cT_","errorLogs":"styles_errorLogs__2GyKJ"};